module.exports = __webpack_public_path__ + "static/media/inbox.8c292cbc.svg";